import { Injectable } from '@angular/core';
import { Observable } from 'rxjs';
import { io, Socket } from 'socket.io-client';
import { IRealTimeTracking } from '../../interfaces/tracking.interface';
import { environment } from 'src/environments/environment';
@Injectable({
  providedIn: 'root'
})
export class TrackingSocketService {

  private readonly server = environment.tracking;
  private socket!: Socket;

  constructor() {}

  connect(): void {
    this.socket = io(this.server, { transports: ["websocket", "polling"] });
  }

  onGetLocations(uuid: string): Observable<IRealTimeTracking> {
    return new Observable((observer) => {
      this.socket.on(`tracking/${uuid}`, (data: IRealTimeTracking) => {
        observer.next(data);
      });
    });
  }

  disconnect(): void {
    if(this.socket) {
      this.socket.disconnect();
    }
  }
}
